import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  // {
  //   title: "Họ và tên",
  //   renderCell: (row) => row.FullName,
  // },
  // {
  //   title: "Đơn vị đề nghị",
  //   renderCell: (row) => row.RequestingUnit,
  // },
  // {
  //   title: "Số điện thoại",
  //   renderCell: (row) => row.PhoneNumber,
  // },
  {
    title: "STT",
    renderCell: (row, index) => index,
  },
  {
    title: "Loại xe",
    renderCell: (row) => row.TypeVehicle,
  },
  {
    title: "Số lượng",
    renderCell: (row) => row.Amount,
  },
  {
    title: "Hành trình",
    renderCell: (row) => row.TripItineraty,
  },
  {
    title: "Thời gian bắt đầu",
    renderCell: (row) => row.StartDate,
  },
  {
    title: "Thời gian kết thúc",
    renderCell: (row) => row.EndDate,
  },
  // {
  //   title: "Lý do sử dụng xe công vụ",
  //   renderCell: (row) => row.Reason,
  // },
];
